import React, { useState, useEffect } from 'react';
//import { toast } from 'react-toastify'

import { Autocomplete, TextField } from '@mui/material';
import { sortDropdownOptions } from '../utils';

function FilterContractType({
    setContractType,
	ContractType,
	setContractTypeId,
	ContractTypeId,
    setContractVariation,
    setContractVariationId,
    ClientId,
    CategoryId,
    VendorNameId
}) {
    
    
    const contractTypeOptions = ['Master Contract','Child Contract'];

    const [options] = useState(() => sortDropdownOptions(contractTypeOptions));
	const [Focus, setFocus] = useState(false);


    useEffect(() => {
		setContractTypeId(null)
		setContractType(null)
	}, [ClientId, CategoryId, VendorNameId, setContractTypeId, setContractType]);

    function changeProjectType(val) {
		setContractType(val);
        setContractVariation(null)
        setContractVariationId(null)
		let obj = contractTypeOptions.indexOf(val)+1;
		if (obj) {
			setContractTypeId(obj);
		}
        else{
			setContractTypeId(null)
			setContractType(null)
		}
	}

    return (
        <>
            <div>
                <div className="flex gap-3">
                    <div className="grow">
                        <div className="lightT">
                            <Autocomplete
                                disablePortal
                                isOptionEqualToValue={(option, value) =>
                                    option === value || value === '' || value == null
                                }
                                id="combo-box-demo"
                                options={options}
                                value={ContractType}
                                renderInput={(params) => (
                                    <TextField {...params} label="Contract Type *" />
                                )}
                                onChange={(event, value) => changeProjectType(value)}
                                onFocus={() => setFocus(true)}
                                onBlur={() => setFocus(false)}
                                // onInputChange={(event, newInputValue) => {
                                //     setProjectType(newInputValue);
                                //   }}
                            />
                            
                            {ContractType == null && Focus && (
								<small className="text-red-600 ">
									Contract type is required
								</small>
							)}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FilterContractType;
